module.exports = "<md-toolbar><div flex class=md-toolbar-tools><h2 flex class=ellipsis><span translate={{vm.dialogTitle}} gz-auto-tooltip=\"{{vm.dialogTitle | translate}}\"></span></h2><md-button aria-label=\"{{'uxf.uxf.Dialog_Cancel' | translate}}\" ng-click=vm.cancel() class=md-icon-button><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg></md-icon></md-button></div></md-toolbar>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/dialog-title-bar/dialog-title-bar.jade
// module id = 227
// module chunks = 0